(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    // With a bundle on, the bar steps aside instead of showing a wrong distance
  // to the threshold. The drawer redraws its tier on the base less the bundle
  // (rendi-cart-ui.js), but this page doesn't load that script: the drawer
  // section bails out on the cart template. Nothing shown beats something
  // wrong, and the whole bar goes rather than leaving a lone line of text.
  (function () {
    function sync(bar) {
      var source = bar.querySelector('.bundler-cart-discount-value-no-minus');
      var digits = source ? source.textContent.replace(/\D/g, '') : '';
      bar.style.display = parseInt(digits, 10) > 0 ? 'none' : '';
    }

    function init() {
      var bar = document.querySelector('.free-shipping-bar');
      if (!bar) return;
      // The AJAX merge only refreshes this bar's attributes and texts, so the
      // node (and the observer) survives it; re-sync anyway, the merge rewrites
      // the style attribute this sets.
      sync(bar);
      if (bar.dataset.bundleWatched) return;
      bar.dataset.bundleWatched = '1';
      new MutationObserver(function () {
        sync(bar);
      }).observe(bar, { childList: true, subtree: true, characterData: true });
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('on:cart:after-merge', init);
    init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rendi-credit-widget"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rendi-credit-widget')) {
    customElements.define(
      'rendi-credit-widget',
      class extends HTMLElement {
        connectedCallback() {
          this.pill = this.querySelector('.rendi-credit__trigger');
          this.menu = this.querySelector('.rendi-credit__menu');
          // sticky/transform ancestors break position: fixed, so the sheet is
          // re-parented out of the header once.
          this.sheet = this.nextElementSibling;
          if (this.sheet && this.sheet.matches('rendi-bottom-sheet')) {
            document.body.appendChild(this.sheet);
          } else {
            this.sheet = document.querySelector('rendi-bottom-sheet[data-sheet="rendi-credit-menu"]');
          }

          // same breakpoint as the mobile header layout in header.css
          this.mobile = window.matchMedia('(max-width: 767.98px)');
          this.syncAria();
          this.mobile.addEventListener('change', () => this.syncAria());

          // a plain click opens the menu; anything else (modifiers, sheet not
          // upgraded yet) falls through to the <a href>.
          this.pill.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (this.mobile.matches) {
              if (!this.sheet || typeof this.sheet.open !== 'function') return;
              event.preventDefault();
              // the sheet restores focus to whatever opened it
              this.sheet.lastFocused = this.pill;
              this.sheet.open();
              return;
            }
            event.preventDefault();
            this.toggle(this.menu.hidden);
          });
          document.addEventListener('click', (event) => {
            if (!this.menu.hidden && !this.contains(event.target)) this.toggle(false);
          });
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !this.menu.hidden) {
              this.toggle(false);
              this.pill.focus();
            }
          });
        }

        // mobile opens a dialog, desktop the dropdown: the trigger must never
        // advertise both, and the affordance of the other side gets closed.
        syncAria() {
          if (this.mobile.matches) {
            // never leave the desktop dropdown hanging below the breakpoint
            this.menu.hidden = true;
            this.pill.setAttribute('aria-haspopup', 'dialog');
            this.pill.removeAttribute('aria-expanded');
            this.pill.removeAttribute('aria-controls');
            return;
          }
          // nor the sheet above it, or its body scroll lock stays on
          if (this.sheet && typeof this.sheet.close === 'function') this.sheet.close();
          this.pill.removeAttribute('aria-haspopup');
          this.pill.setAttribute('aria-expanded', this.menu.hidden === false);
          this.pill.setAttribute('aria-controls', 'rendi-credit-menu');
        }

        toggle(open) {
          this.menu.hidden = !open;
          if (!this.mobile.matches) this.pill.setAttribute('aria-expanded', open);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rendi-cur-card"] && !Shopify.designMode) return;
  try {
    // Le ancore di questa card le porta il JS, e non è una preferenza: sul tema
  // il <body> ha `overflow-y: scroll`, quindi è lui il contenitore di
  // scorrimento più vicino a qualunque bersaglio. Il suo `scrollHeight` è
  // uguale al `clientHeight`, quindi non scorre, e sia l'ancora nativa sia
  // `scrollIntoView()` si fermano lì senza muovere niente. `window.scrollTo`
  // invece scorre, misurato sulla preview dell'11 settembre 2026.
  // La causa è del tema e non di queste ancore: qui si aggira per le proprie,
  // non si tocca il <body> di tutto il sito.
  //
  // Lo scostamento lo legge dallo `scroll-margin-top` del bersaglio, così
  // l'altezza dell'header sticky resta dichiarata nel CSS e in un posto solo.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href^="#"]');
    if (!link || !link.closest('[data-rendi-cur-card]')) return;

    var id = link.hash.slice(1);
    var target = id && document.getElementById(decodeURIComponent(id));
    if (!target) return;

    event.preventDefault();

    // `instant` e non `smooth`, e non e' una preferenza estetica: su questa
    // pagina lo scorrimento morbido non arriva mai a destinazione. Misurato
    // sulla preview dell'11 settembre 2026, a pagina appena caricata e con un
    // click vero: con `smooth` la posizione resta 0 anche dopo un secondo e
    // mezzo, con `instant` atterra subito sul bersaglio. Il salto e' brusco, ma
    // un'ancora che non si muove e' peggio.
    var offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - offset,
      behavior: 'instant',
    });

    // Quello che avrebbe fatto l'ancora nativa: l'indirizzo resta
    // condivisibile e il fuoco segue lo sguardo di chi naviga da tastiera.
    history.replaceState(null, '', link.hash);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
